export default __webpack_public_path__ + "images/b3291ba3-man_people_person.svg";